import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { TitlesService } from './titles.service';
import { Title } from 'src/app/shared/models/title.model';
import { Subscription } from 'rxjs';
import { Stock } from 'src/app/shared/models/stock.model';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ImageUploadComponent } from '../images/image-upload/image-upload.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { Response } from 'src/app/shared/models/response.model';
import { AuthUser } from 'src/app/shared/models/auth-user.model';
import { FileSaverService } from 'ngx-filesaver';
import { TitleDownloadComponent } from './title-download/title-download.component';
import { Download } from 'src/app/shared/models/download.model';
import { Trademark } from 'src/app/shared/models/trademark.model';

import { MsAdalAngular6Service } from 'microsoft-adal-angular6';
import { Profile } from 'src/app/shared/models/profile.model';

@Component({
  selector: 'app-titles',
  templateUrl: './titles.component.html',
  styleUrls: ['./titles.component.scss']
})
export class TitlesComponent implements OnInit, OnDestroy {

  isSelected: boolean;
  Selected: boolean;
  checkedList: string[];
  titles: Title[];
  stocks: Stock[];
  trademarks: Trademark[];
  filterForm: FormGroup;
  modalOptions: NgbModalOptions;
  modalOptionsToDownload: NgbModalOptions;
  offset: number;
  total: number;
  maxPageSize: number;
  currentUser: AuthUser;
  userName: string;
  download: boolean;
  fileUrl;
  currentDate = new Date();
  dateToZip: string;
  downloadObject: Download;
  useroffice365: string;
  profile: Profile;

  private titlesSubscription: Subscription = null;
  private stocksSubscription: Subscription = null;
  private trademarkSubscription: Subscription = null;
  private loginSubscription: Subscription = null;

  constructor(private titlesService: TitlesService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private modalServiceToDownload: NgbModal,
    private loader: NgxSpinnerService,
    private router: Router,
    private fileSaverService: FileSaverService,
    private adalSvc: MsAdalAngular6Service) {

    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg',
    };

    this.modalOptionsToDownload = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg',
    };

    this.profile = new Profile({});

    if (this.adalSvc.userInfo !== null) {
      this.profile = this.adalSvc.userInfo;

      this.setSession();
    } else {

      localStorage.removeItem('gbi_auth_user');
      localStorage.removeItem('gbi_expires_at');

    }

  }


  /**
   * OnInit
   */
  ngOnInit(): void {

    this.filterForm = this.formBuilder.group({
      mark: [''],
      term: [''],
      termdownload: [''],
      limit: 25,
    });

    this.titles = [];
    this.stocks = [];
    this.trademarks = [];
    this.maxPageSize = 5;
    this.offset = 1;
    this.total = 0;

    this.download = true;

    this.checkedList = new Array();

    this.dateToZip = this.currentDate.toLocaleDateString();

  }

  setSession() {

    this.loader.show();

    this.loginSubscription = this.titlesService.login(this.profile.userName)
      .subscribe((result: any) => {
        if (result.is_valid) {

          // Set the time that the Access Token will expire at
          const expiresAt = JSON.stringify((result.expires_at * 1000) + new Date().getTime());
          const authUser = JSON.stringify(result.auth_user);

          /* const expiresAt = JSON.stringify((2700 * 1000) + new Date().getTime());
          const authUser = JSON.stringify('{"user_id":4,"firstname":"Alejandra","lastname":"Barrera","email":"abarrera@larousse.com.mx","rol":{"rol_id":1,"name":"Administrador","description":null,"created_date":"0001-01-01T00:00:00"},"created_date":"0001-01-01T00:00:00"}'); */

          localStorage.setItem('gbi_auth_user', authUser);
          localStorage.setItem('gbi_expires_at', expiresAt);

          /* localStorage.setItem('gbi_auth_user', '{"user_id":4,"firstname":"Alejandra","lastname":"Barrera","email":"abarrera@larousse.com.mx","rol":{"rol_id":1,"name":"Administrador","description":null,"created_date":"0001-01-01T00:00:00"},"created_date":"0001-01-01T00:00:00"}');
          localStorage.setItem('gbi_expires_at', '1704928385386'); */

          this.getFilters();

         this.loader.hide();
        } else {
          this.loader.hide();
          this.toastr.error(result.message);
        }
      },
        (error) => {
          this.loader.hide();
          // this.toastr.error(`Hubo un problema a intentar obtener los datos de sesión: ${error.message}`);
          // console.log('Hubo un problema a intentar obtener los datos de sesión');
          console.log("error: " + error.message);
        });

  }

  /**
   * OnDestroy
   */
  ngOnDestroy(): void {
    if (this.titlesSubscription !== null) { this.titlesSubscription.unsubscribe(); }
    if (this.stocksSubscription !== null) { this.stocksSubscription.unsubscribe(); }
    if (this.trademarkSubscription !== null) { this.trademarkSubscription.unsubscribe(); }
    if (this.loginSubscription !== null) { this.loginSubscription.unsubscribe(); }
  }

  /**
   *
   */
  onStockChange() {
    const currentStock = this.filterForm.get('mark').value;
    const currentTerm = this.filterForm.get('term').value;
    const currentLimit = this.filterForm.get('limit').value;

    this.getTitles(currentStock, currentTerm, this.offset, currentLimit);
  }

  /**
   * 
   */
  onPageChange() {
    const currentStock = this.filterForm.get('mark').value;
    const currentTerm = this.filterForm.get('term').value;
    const currentLimit = this.filterForm.get('limit').value;

    this.getTitles(currentStock, currentTerm, this.offset, currentLimit);
  }

  /**
   *
   * @param searchTerm
   */
  onSearch(searchTerm: string) {
    const currentStock = this.filterForm.get('mark').value;
    const currentLimit = this.filterForm.get('limit').value;

    this.getTitles(currentStock, searchTerm, this.offset, currentLimit);
  }

  onSearchToDownload(searchTerm: string) {

    this.loader.show();

    this.download = false;
    const currentLimit = this.filterForm.get('limit').value;
    const finalTerm = searchTerm.replace(/ /g, '');

    this.titlesSubscription = this.titlesService.getTitlesToDownload(finalTerm, this.offset, currentLimit)
      .subscribe((resultToDownload: Response) => {
        this.total = resultToDownload.total;
        this.titles = resultToDownload.items;
        this.loader.hide();

        if (this.titles.length === 0) {
          this.toastr.info('No se encontraron titulos relacionados');
        }
      }, (error) => {
        this.loader.hide();
        console.error(error.message);
      });

  }
  /**
   * 
   * @param stock 
   * @param term 
   * @param offset 
   * @param limit 
   */
  getTitles(stock: number, term: string, offset: number, limit: number) {
    this.loader.show();

    if (term === '') {
      this.titlesSubscription = this.titlesService.getTitles(stock, offset, limit).subscribe((result: Response) => {
        this.total = result.total;
        this.titles = result.items;
        console.log(result.items);
        this.loader.hide();

        if (this.titles.length === 0) {
          this.toastr.info('No se encontraron titulos relacionados a esta marca');
        }
      }, (error) => {
        this.loader.hide();
        console.error(error.message);
      });
    } else {

      this.titlesSubscription = this.titlesService.getTitlesByFilter(term, offset, limit).subscribe((result: Response) => {
        this.total = result.total;
        this.titles = result.items;
        this.loader.hide();

        if (this.titles.length === 0) {
          this.toastr.info('No se encontraron titulos en el banco seleccionado');
        }
      }, (error) => {
        this.loader.hide();
        console.error(error.message);
      });


    }
  }

  /**
   *
   */
  getFilters() {
    this.loader.show();

    Promise.all([
      this.titlesService.getStocks(),
      this.titlesService.getTrademarks(),
    ]).then((result: any) => {
      this.loader.hide();
      this.stocks = result[0] as Stock[];
      this.trademarks = result[1] as Trademark[];

      if (this.stocks.length === 0) {
        this.toastr.info('No se encontraron bancos disponibles');
        return;
      }

      this.filterForm.patchValue({
        mark: this.trademarks[0].idtrademark,
        term: ''
      });
      this.onStockChange();

    }).catch((error) => {
      console.error(error.message);
    });
  }

  /**
   *
   */
  onAddImage(title: Title): void {

   const modalRef = this.modalService.open(ImageUploadComponent, this.modalOptions);
    modalRef.componentInstance.paramTitle = title;
    modalRef.componentInstance.paramStockId = this.filterForm.get('mark').value;
    modalRef.result.then((result) => {
      this.onStockChange();
    }, (reason) => { }); 

     /*  this.router.navigate(['screen-gbp', { isbn: '411999'}]); */
  }

  /**
   * Redirect to ticket detail
   */
  gotoTitleDetail(row: Title): void {
    const currentStockId = this.filterForm.get('mark').value;
    this.router.navigate(['/titles/title-detail', { title: JSON.stringify(row), stock: JSON.stringify(currentStockId) }]);
  }

  onCheckboxChange(option, event) {
    if (event.target.checked) {
      this.checkedList.push(option.images.identifier);
    } else {
      for (let i = 0; i < this.titles.length; i++) {
        if (this.checkedList[i] === option.images.identifier) {
          this.checkedList.splice(i, 1);
        }
      }
    }
  }

  selectedAll(ev): void {
    this.isSelected = ev.target.checked;

    if (this.isSelected !== true) {
      this.checkedList = new Array();
    }
    else {
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < this.titles.length; i++) {
        this.checkedList.push(this.titles[i].images.identifier);
      }
    }

  }

  toDownloadImages(): void {

    const modalRef = this.modalServiceToDownload.open(TitleDownloadComponent, this.modalOptionsToDownload);
    modalRef.result.then((result) => {

      this.downloadObject = result;

      this.loader.show();

      const finalarray = this.checkedList.toString();

      this.titlesSubscription = this.titlesService.downloadImages(finalarray, this.downloadObject).subscribe((result: any) => {

        this.loader.hide();

        this.fileSaverService.save(result, 'DescargaGBI' + this.dateToZip + '.zip');

      }, (error) => {
        this.loader.hide();
        console.error(error.message);
      });

    }, (reason) => { });

  }

}
